import * as React from 'react';
import { Reference, ReferenceProps } from 'react-popper';
import { PlacementManagerContext } from './PlacementManagerContext';

export interface Props extends ReferenceProps {}

/**
 * The reference component handles setting the target element ref with the
 * PlacementManager.
 */
const PlacementReference: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <PlacementManagerContext.Consumer>
      { ({ setReferenceNode }) => (
        <Reference { ...props } innerRef={ setReferenceNode } />
      ) }
    </PlacementManagerContext.Consumer>
  );
};

export default PlacementReference;
